export default __webpack_public_path__ + "static/media/appstore.bbf8f6a5.png";